const homeData = {

    categories : [
                    {
                      id: 1,
                      category: "autres",
                      title: "SERVICES D’INSTALLATION ET DE MAINTENANCE GÉNÉRALE",
                      desc: "ORTEGA assure des services de maintenance multi-techniques incluant l’électricité, la plomberie et autres interventions techniques, avec des équipes qualifiées et réactives.",
                      img: './img/psd-7.png',
                      size: 'col-md-12',
                      bg: '#212529',
                      detail: false
                    },
                    {
                      id: 2,
                      category: "informatique",
                      title: "INSTALLATION ET MAINTENANCE INFORMATIQUE",
                      desc: "Nous assurons l’installation, la maintenance et le support des infrastructures informatiques afin de garantir performance, sécurité et continuité de service.",
                      img: './img/psd-3.png',
                      size: 'col-md-6',
                      bg: '#f1f2e9',
                      detail: true
                    },
                    {
                      id: 3,
                      category: "biomedicale",
                      title: "INSTALLATION ET MAINTENANCE BIOMÉDICALE",
                      desc: "ORTEGA accompagne les structures de santé dans l’installation et la maintenance d’équipements biomédicaux, en conformité avec les normes et exigences du secteur.",
                      img: './img/psd-1.png',
                      size: 'col-md-6',
                      bg: '#e5e8eb',
                      detail: true
                    }

                 ],

    services :   [
                    {
                      icon: 'bi-truck',
                      title: 'Livraison maîtrisée',
                      description: 'Gestion, suivi et livraison des commandes'
                    },
                    {
                      icon: 'bi-arrow-repeat',
                      title: 'Suivi & assistance',
                      description: 'Maintenance et support technique réactif.'
                    },
                    {
                      icon: 'bi-shield-lock',
                      title: 'Fiabilité & conformité',
                      description: 'Produits certifiés, solutions sécurisées.'
                    },
                    {
                      icon: 'bi-people',
                      title: 'Équipe disponible 7j/7',
                      description: 'Une équipe commerciale et technique à vos besoins.'
                    }

                 ],

    bottomData :     [
                    {
                      id: 1,
                      title: "Vente et livraison d’équipements",
                      desc: "ORTÉGA assure la vente et la livraison d’équipements biomédicaux, informatiques et de mobilier, avec une gestion rigoureuse des commandes et le respect des délais."
                    },
                    {
                      id: 2,
                      title: "Installation et maintenance",
                      desc: "Nous prenons en charge l’installation, la maintenance préventive et corrective de vos équipements afin de garantir leur performance, leur sécurité et leur durabilité."
                    },
                      {
                      id: 3,
                      title: "Conception et déploiement de logiciels",
                      desc: "Nous créons des solutions logicielles personnalisées pour des entreprises et des professionnels de santé, optimisant la gestion, la productivité et la transformation digitale."
                    },
                 ]

}


export default homeData;